import React, {useEffect, useState} from 'react';
import './index.scss';
import {
  Col,
  Row,
  Tabs,
  Typography,
  Card, List, notification, Skeleton, Rate, Spin, Avatar, Form, Input, Button, Tag,
} from 'antd';
import API_SERVICE from 'shared/services/api-service';
import {useParams, Link, useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
  ClockCircleOutlined,
  PlayCircleTwoTone,
  PlayCircleOutlined,
  FolderOpenTwoTone,
  ShoppingCartOutlined,
  QuestionCircleTwoTone,
  FlagOutlined,
  FilePdfOutlined,
  FolderOpenOutlined, HeartFilled, EyeFilled,
} from '@ant-design/icons';
// @ts-ignore
import moment from 'moment';
import { Collapse } from 'antd';

import Parameters from 'shared/parameters';
import TextArea from 'antd/es/input/TextArea';
import {AuthConsumer} from 'shared/contexts/AuthContext';
import {useMedia} from 'react-use';
import breadcrumbArrow from '../../../src/img/breadcrumb-arrow.png';
import HowItWorks from '../AllCourses/HowItWorks';
import star from '../../img/star-fill.png';
import checked from '../../img/checked.png';

const {TabPane} = Tabs;
const {Title, Text} = Typography;
const { Panel } = Collapse;
export default function CourseDetailsPage() {
  const RouteParams: any = useParams();
  const history: any = useHistory();
  const shouldWrap: boolean = useMedia('(max-width: 768px)');

  const {t}: any = useTranslation();
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState(null as any);
  const refresh = () => {
    
    setLoading(true);
    API_SERVICE.fetchCourseById(RouteParams['id']).then((courses) => {
      setCourse(courses.data.data);
    }).catch((e) => {
      notification.error({
        message: API_SERVICE.handleErrors(e),
      });
    }).finally(() => {
      setLoading(false);
    });
    var userId;
    const userDetails = JSON.parse(localStorage.getItem('auth-token') as any);
    if (localStorage.getItem('auth-token') !== null) {
     userId = {"userId" : userDetails.user.id};
    }else{
      userId = 0;
    }



    API_SERVICE.courseClickCount(RouteParams['id'], userId).then((result) => {
      console.log('result',result);
    }).catch((e) => {
      console.log(e)
    })
  };
  useEffect(() => {
    refresh();
  }, []);
  if (loading || !course) {
    return <Skeleton active={true}/>;
  }
  return (
    <AuthConsumer>
      {({isAuth, user, updateCartTime}) => <><div className={'course-details-page'}>
        <div className={'layout-wrapper'}>
          <div className="bg-white px-sm-2">
            {/* {console.log('itemmmmmsss', course)} */}
            <div className="container-fluid d-lg-flex align-items-center justify-content-space-between plr-4rem pt-4">
              <div className="breadcrumb bg-white pl-0 mb-0 mt-4">
                <span className="text-secondary">{t('genDict.Home')}</span>&nbsp;&nbsp;
                <span><img src={breadcrumbArrow} className="breadcrumb-arrow" /></span>&nbsp;&nbsp;
                <span className="text-secondary">{t('genDict.BrowseCourse')}</span>&nbsp;&nbsp;
                <span><img src={breadcrumbArrow} className="breadcrumb-arrow" /></span>&nbsp;&nbsp;
                <span className="text-secondary">{course.title}</span>
              </div>
              <div className="mt-4">
                <div className="module-tabs category-tabs">
                  <ul className="nav nav-tabs bg-white">
                    <li className="active p-2">
                      <a data-toggle="tab" href="#overViewSection" className="active">
                        <p className="mb-0 bold-500">{t('genDict.Overview')}</p>
                      </a>
                    </li>
                    {/* <li className="p-2">
                      <a data-toggle="tab" href="#contentSection">
                        <p className="mb-0 bold-500">{t('genDict.content')}</p>
                      </a>
                    </li> */}
                    <li className="p-2">
                      <a data-toggle="tab" href="#benefitSection">
                        <p className="mb-0 bold-500">{t('genDict.Benefits')}</p>
                      </a>
                    </li>
                    <li className="p-2">
                      <a data-toggle="tab" href="#reviewSection">
                        <p className="mb-0 bold-500">{t('genDict.review')}</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div id='overViewSection' className="container-fluid plr-4rem">
              <div className="row">
                <div className="col-md-5 mt-4">
                  <div className='pos-relative'>
                    <img src={Parameters.ImageBaseUrl + course.thumbnail.slug + course.thumbnail.ext} className="img-fluid w-100" />
                    <div className='top-left'>
                        {course?.level?.name && <span className="labeled featured small d-flex align-items-center" style={{padding: '0px 10px'}}>{course.level.name}</span>} 
                    </div>
                  </div>
                </div>
                <div className="col-md-7 mt-4">
                  <h4>{course.title}</h4>
                  <RenderAverageRating course={course} />
                  <p className="mb-0 mt-3 short-desc line-clamp-3">{course.short_description}</p>
                  <PricePurchase refresh={refresh} updateCartTime={updateCartTime} isAuth={isAuth}
                    course={course} />
                </div>
              </div>
            </div>
            <div className="container mt-4">
              <div className="pl-sm-4 pr-sm-4 pl-md-5 pr-md-5">
                <div className="d-md-flex flex-wrap pt-4 pb-4 pl-md-5 pr-md-5 pl-sm-4 pr-sm-4 pr-2 pl-2 bg-F9FAFB">
                  <div className="mr-2 w-100">
                    <ul className='list-style-none w-100 d-md-flex justify-content-space-between align-items-center'>
                      <li className="mr-2 text-center text-md-left mt-md-0 mt-4">
                        <p className='mb-1'>Enrolled</p>
                        <ul className='list-style-none center-xs d-flex align-items-center' style={{ flexWrap: "nowrap" }}>
                          {course.course_users && course.course_users.slice(0, 5).map((courseUser: any, sIndex: any) => {

                            return <>
                              {courseUser.avatar_image ?
                                <li className='li-enrolled-img'>
                                  <img src={Parameters.ImageBaseUrl + courseUser.avatar_image.slug + courseUser.avatar_image.ext} className='img-enrolled' />
                                </li>
                                : <li className='li-enrolled-img'>
                                  <img src={Parameters.ImageBaseUrl + 'avatar.png'} className='img-enrolled' />
                                </li>}
                            </>;
                          })}
                          {course.course_users.length <= 0 ?

                            <><p className="m-auto mt-0 mb-0">0</p></>
                            :
                            ''}
                          {course.course_users.length > 5 ?
                            <li className='small text-4f46e5 ml-2'> + {course.course_users.length - 5}</li>
                            : ''}
                        </ul>
                      </li>
                      {/* <li className='mr-2 text-center mt-md-0 mt-4'>
                        <span>Graduated</span><br />
                        <span>{Math.round((course.course_users.length * 60) / 100)}</span>
                      </li> 
                      <li className='mr-2 text-center mt-md-0 mt-4'>
                        <span>{t('genDict.Module')}</span><br />
                        <span>{course.curriculums.length}</span>
                      </li>
                      <li className='mr-2 text-center mt-md-0 mt-4'>
                        <span>{t('genDict.lectures')}</span><br />
                        <span>{course.lectures_count}</span>
                      </li>
                      <li className='mr-2 text-center mt-md-0 mt-4'>
                        <span>{t('genDict.Quiz')}</span><br />
                        <span>{course.quizes_count}</span>
                      </li>*/}
                      {/* <li className='mr-2 text-center mt-md-0 mt-4'>
                        <span>Duration</span><br />
                        <span>{Math.round((course.duration) / 60)}h</span>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {course.description !== '' && <div className="container-fluid plr-4rem mt-5">
              <h3 className="mb-5">{t('genDict.description')}</h3>
              <div className="pl-sm-4 pr-sm-4 pl-md-5 pr-md-5 mt-4">
                <p className="mb-0">{course.description}</p>
              </div>
            </div>
            }
            
            {/* {course.curriculums.length ? <CurriculumList course={course} /> : <></>} */}

            {course.benefits !== '' && <div id='benefitSection' className="container-fluid plr-4rem mt-5">
              <h3 className="mb-5">{t('genDict.Benefits')}</h3>
              <div className="pl-sm-4 pr-sm-4 pl-md-5 pr-md-5 mt-4">
                <div
                  dangerouslySetInnerHTML={{ __html: course.benefits }} />
            
                {/* <ul className="list-style-none">
        <li className="mb-4">
            <div className="d-flex">
                <img src="assets/img/benefit-check.png" className="mr-3 mt-1 benefit-check" />
                <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.</span>
            </div>
        </li>
        <li className="mb-4">
            <div className="d-flex">
                <img src="assets/img/benefit-check.png" className="mr-3 mt-1 benefit-check" />
                <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.</span>
            </div>
        </li>
        <li className="mb-4">
            <div className="d-flex">
                <img src="assets/img/benefit-check.png" className="mr-3 mt-1 benefit-check" />
                <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.</span>
            </div>
        </li>
        <li className="mb-4">
            <div className="d-flex">
                <img src="assets/img/benefit-check.png" className="mr-3 mt-1 benefit-check" />
                <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.</span>
            </div>
        </li>
    </ul>
    <div className="bg-benefit text-white pos-relative">
        <div className="apply-overlay"></div>
        <div className="pos-relative benefit-notes">
            <p>Learn new skills and Grow higher in your career</p>
            <ul className="list-style-none">
                <li className="mb-4">
                    <div className="d-flex">
                        <img src="assets/img/benefit-check-white.png" className="mr-3 mt-1 benefit-check" />
                        <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. </span>
                    </div>
                </li>
                <li className="mb-4">
                    <div className="d-flex">
                        <img src="assets/img/benefit-check-white.png" className="mr-3 mt-1 benefit-check" />
                        <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. </span>
                    </div>
                </li>
                <li className="mb-4">
                    <div className="d-flex">
                        <img src="assets/img/benefit-check-white.png" className="mr-3 mt-1 benefit-check" />
                        <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt.</span>
                    </div>
                </li>
                <li className="mb-4">
                    <div className="d-flex">
                        <img src="assets/img/benefit-check-white.png" className="mr-3 mt-1 benefit-check" />
                        <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt.</span>
                    </div>
                </li>
                <li className="mb-4">
                    <div className="d-flex">
                        <img src="assets/img/benefit-check-white.png" className="mr-3 mt-1 benefit-check" />
                        <span>Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz.Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt.</span>
                    </div>
                </li>
            </ul>
        </div>
        <div className="benefit-tag">
            <img src="assets/img/img-benefit.png" style={{maxWidth:"200px"}}/>
            <h1 className="mt-4 text-white text-lg-center">$69.00</h1>
            <p className="mb-1 text-lg-center"><span className="offer-time">Limited time offer</span></p>
            <p className="mb-0 mt-3 text-lg-center">
                <a href="#" className="btn btn-success text-uppercase">
                    Apply Now
                    <span>
                        <img src="assets/img/apply-icon.png" className="ml-2" style={{width:"14px"}} />
                    </span>
                </a>
            </p>
        </div>
    </div> */}
              </div>
            </div>
            }
            {/* <HowItWorks /> */}
            <div id='reviewSection' className="container-fluid bg-white pt-5 pb-5 plr-4rem">
              <div className='d-flex align-items-center justify-content-space-between'>
                <div>
                  <h4>{t('genDict.reviews')}</h4>
                  <p className="mb-0">{t('genDict.WhatOurStudentsaying')}</p>
                </div>
                {/* <div>
                  <button className='btn btn-blue' data-toggle="modal" data-target="#addReview">Add Review</button>
                </div> */}
              </div>
              <div className="row">
                {course.reviews && course.reviews.map((courseReview: any) => {
                  return <div className="col-md-4 col-sm-12 mt-4">
                    <div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  light-shadow">
                      <blockquote className="review">
                        {/* <p>{courseReview.review}</p> */}
                        <div className="mt-4 d-flex align-items-center justify-content-space-between">
                          <div className="d-flex align-items-center">
                            <img src={Parameters.ImageBaseUrl + courseReview?.user?.avatar_image?.slug + courseReview?.user?.avatar_image?.ext} className="rounded-circle" style={{width:"45px"}} />
                            <span className="ml-2">{courseReview?.user?.name}</span>
                          </div>
                          <div className="d-flex align-items-center">
                            <img src={star} style={{ width: "17px" }} />
                            <span className="ml-2">{courseReview?.rating}</span>
                          </div>
                        </div>
                      </blockquote>
                    </div>
                  </div>;
                })}
              </div>
            </div>  
          </div>
          {/* <Row gutter={[20, 20]} wrap={shouldWrap}>
      <Col flex={'auto'}>
        <Row gutter={[20, 20]}>
          <Col flex={'auto'}>
            <div className="title">
              <Row gutter={20}>
                <Col flex={'auto'}>
                  <Title level={3}>{course.title}</Title>
                </Col>
                <Col>
                  <RenderAverageRating course={course}/>
                </Col>
              </Row>
              <Title level={5}>
                <div dangerouslySetInnerHTML={{__html: course.short_description}}/>
              </Title>

              <div className="image-layout-section">
                <div className="large-image" style={{
                  backgroundImage: `url(${Parameters.ImageBaseUrl + course.thumbnail.slug + course.thumbnail.ext})`,
                }}>

                </div>
              </div>
            </div>
          </Col>

        </Row>
        <Row gutter={[20, 20]}>
          <Col flex={'auto'}>

            <div className="table-description-section">
              <Tabs defaultActiveKey="1" size={'large'}>
                <TabPane tab={t('genDict.description')} key="1">
                  <Card>
                    <div dangerouslySetInnerHTML={{__html: course.description}}/>
                  </Card>
                </TabPane>

                <TabPane tab={t('genDict.curriculum')} key="2">
                  <CurriculumList course={course}/>
                </TabPane>
                <TabPane tab={t('genDict.reviews')} key="3">
                  <ReviewsList refresh={refresh} course={course}/>
                </TabPane>
                <TabPane tab={t('genDict.meetings')} key="4">
                  <MeetingsList course={course}/>
                  {
                    isAuth ?
                      <MeetingsList course={course}/>
                      : <div>
                        <Title level={3}>{t('genDict.loginNeeded')}</Title>
                        <Button type={'primary'} onClick={
                          () => {
                            history.push('/login');
                          }
                        }>{t('genDict.login')}</Button>
                      </div>
                  }
                </TabPane>

              </Tabs>
            </div>
          </Col>
        </Row>
      </Col>
      <Col flex={'300px'}>
        <div className="side-bar-item">
          <PricePurchase refresh={refresh} updateCartTime={updateCartTime} isAuth={isAuth}
                            course={course}/>
        </div>
      </Col>
    </Row> */}
        </div>
      </div></>
      }
    </AuthConsumer>

  );
}

function RenderAverageRating({course}: any) {
  const {t}: any = useTranslation();
  const [ratings, setRatings] = useState(null as any);
  useEffect(() => {
    API_SERVICE.fetchCourseReviewsByCourseId(course.id).then(({data: {data}}) => {
      const {total, totalRating} = data;
      setRatings({total, totalRating: parseFloat(totalRating + '')});
    }).catch((e) => {
      notification.error({
        message: API_SERVICE.handleErrors(e),
      });
    });
  }, []);
  if (!ratings) {
    return <Spin/>;
  }
  return <div><Rate disabled allowHalf
                    defaultValue={(isNaN(ratings.totalRating / ratings.total) || !ratings.total) ? 0 : (ratings.totalRating / ratings.total)}/> ({ratings.total})
  </div>;
}

function CurriculumList({course}: any) {
  const {t}: any = useTranslation();
  return <div className={'curriculum-wrapper'}>
    
        <div id='contentSection' className="container-fluid plr-4rem mt-5">
          <h3 className="mb-5">{t('genDict.content')}</h3>
          <div className="pl-sm-4 pr-sm-4 pl-md-5 pr-md-5 mt-4 course-detail-content-collapse contentCollapse">
          <Collapse defaultActiveKey={['1']} onChange={() => {}}>
                                {
                                  course.curriculums && course.curriculums.map((curriculumItem: any,cindex:any) => {
                                    return <Panel header={
                                        <div>
                                            <div>
                                                <h6 className="mb-0"><strong><span className="mr-2">{t('genDict.Module')} {cindex + 1}:</span><span>{curriculumItem?.title}</span></strong></h6> 
                                            </div>
                                        </div>
                                        
                                    } key={curriculumItem.id}>
                                        {curriculumItem.contents && curriculumItem.contents.map((curriculumContent: any,contentindex:any) => {
                                          return <div className="content-table-div table-responsive">
                                          <table className="table module-table mb-0">
                                              <tbody>
                                                <tr className="box-shadow bg-white">
                                                    <td>
                                                    <Link
                                                    to={`/courses/${course?.id}/curriculums/${curriculumItem?.id}/contents/${curriculumContent?.id}`}
                                                    onClick={(e) => {
                                                      if (!course.isOrdered && !curriculumContent.is_preview) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        notification.error({message: t('courses.purchaseCourseFirst')});
                                                      }
                                                    }}>
                                                      <div>
                                                        <p className="mb-0 bold-500 course-content-title">
                                                        {contentindex + 1}.&nbsp;&nbsp;
                                                        {
                                                          curriculumContent.type === 'lecture' &&
                                                          'Video- '
                                                        }
                                                        {
                                                          curriculumContent.type === 'scorm' &&
                                                          'Lession- '
                                                        }
                                                        {
                                                          curriculumContent.type === 'assignment' &&
                                                          'PDF- '
                                                        }
                                                        {
                                                          curriculumContent.type === 'quiz' &&
                                                          'Quiz- '
                                                        }
                                                          {curriculumContent.title}
                                                        </p>
                                                        <p className="ml-4 course-content-desc">{curriculumContent?.description}</p>
                                                      </div>
                                                    </Link>
                                                    </td>
                                                </tr>
                                              </tbody>
                                          </table>
                                        </div>
                                        })}
                                        

                                    </Panel>
                                  })
                                }
                            </Collapse>
          </div>
        </div>
          {/* <Title level={4}>{curriculum.title}</Title>
          <div
            dangerouslySetInnerHTML={{__html: curriculum.description}}/>
          {
            curriculum.contents.map((content: any) => {
              return <div>
                <Row gutter={20}>
                  <Col flex={'auto'}>
                    <Row gutter={20} align={'top'}>
                      <Col className={'icon-size-30'}>
                        {
                          content.type === 'lecture' &&
                          <PlayCircleTwoTone/>
                        }
                        {
                          content.type === 'scorm' &&
                          <FolderOpenTwoTone/>
                        }
                        {
                          content.type === 'assignment' &&
                          <FolderOpenTwoTone/>
                        }
                        {
                          content.type === 'quiz' &&
                          <QuestionCircleTwoTone/>
                        }
                      </Col>
                      <Col>
                        <Link
                          to={`/courses/${course.id}/curriculums/${curriculum.id}/contents/${content.id}`}
                          onClick={(e) => {
                            if (!course.isOrdered && !content.is_preview) {
                              e.preventDefault();
                              e.stopPropagation();
                              notification.error({message: t('courses.purchaseCourseFirst')});
                            }
                          }}>{content.title}</Link>
                        <div
                          dangerouslySetInnerHTML={{__html: content.description}}/>

                      </Col>
                      {
                        content.is_preview ? <Col>
                          <Tag>
                            {t('genDict.preview')}
                          </Tag>
                        </Col> : <></>
                      }
                    </Row>

                  </Col>
                  <Col>
                    <div style={{
                      marginBottom: '30px',
                      marginTop: '7px',
                    }}>{content.duration_in_minutes}&nbsp;
                      {t('genDict.minutes')}
                    </div>
                  </Col>
                </Row>
              </div>;
            })
          }
          <br/> */}
  </div>;
}

function MeetingsList(
  {
    course,
  }
    : any) {
  const {t}: any = useTranslation();
  const [meetings, setMeetings] = useState([] as any[]);
  const [loading, setLoading] = useState(false);
  const [joining, setJoining] = useState(-1);
  useEffect(() => {
    setLoading(true);
    API_SERVICE.fetchMeetingsByCourseId(course.id).then((m) => {
      setMeetings(m.data.data.items);
    }).catch((e) => {
      notification.error({
        message: API_SERVICE.handleErrors(e),
      });
    }).finally(() => {
      // refreshContent();
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <Spin/>;
  }
  return <div className={'curriculum-wrapper'}>
    {
      meetings.map((meeting: any, index: number) => {
        return <div>
          <Row gutter={[20, 20]}>
            <Col flex={'auto'}>
              <Text>{meeting.title}</Text>
              <div>
                <Text disabled>{moment(meeting.start_date_time).format('LL')}</Text>
              </div>
            </Col>
          </Row>
        </div>;
      })
    }
  </div>;
}


function PricePurchase({course, refresh, updateCartTime, isAuth}: any) {
  const {t}: any = useTranslation();
  const history: any = useHistory();

  const [items, setItems] = useState([] as any[]);
  const [addingToCart, setAddingToCart] = useState(false);
  const [addedToTheCart, setAddedToTheCart] = useState(false);
  const [initiatedPayment, setInitiatedPayment] = useState(false);
  const settings = JSON.parse(localStorage.getItem('settings') as string);
  console.log(settings);
  const addToCart = async () => {
    if (!isAuth) {
      history.push('/login');
      return;
    }
    setAddingToCart(true);
    if (!settings.is_closed) {
      API_SERVICE.addToCart({product_id: course.id, type: 'App\\Course'}).then((courses) => {
        setAddedToTheCart(true);
      }).catch((e) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      }).finally(() => {
        setAddingToCart(false);
        updateCartTime(new Date().getTime());
      });
    } else {
      API_SERVICE.subscribeCourse(course.id).then((courses) => {
        setAddedToTheCart(true);
        refresh();
      }).catch((e) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      }).finally(() => {
        setAddingToCart(false);
      });
    }
    return true;
  };
  useEffect(() => {
    let durationInMinutesLocal = 0;
    let totalLectures = 0;
    let numberOfResources = 0;
    course.curriculums.forEach((c: any) => {
      c.contents.forEach((content: any) => {
        durationInMinutesLocal += parseInt(content.duration_in_minutes);
        if (content.type === 'lecture') {
          totalLectures++;
        }
        if (content.type === 'assignment') {
          numberOfResources++;
        }
      });
    });
    setItems([{
      title: 'genDict.duration',
      icon: <ClockCircleOutlined/>,
      value: durationInMinutesLocal,
    }, {
      title: 'genDict.lectures',
      icon: <FolderOpenOutlined/>,
      value: totalLectures,
    }, {
      title: 'genDict.resources',
      icon: <FilePdfOutlined/>,
      value: numberOfResources,
    }, {
      title: 'genDict.skillLevel',
      icon: <FlagOutlined/>,
      value: course.level.name,
    }]);
  }, []);
  return <AuthConsumer>
  {({isAuth, user, updateCartTime}) =><div>
    <div className="price-box">
    {!course.isOrdered && !settings.is_closed ? 
    
      course.price !== course.sale_price &&
      <><p className="mb-3 text-secondary mt-3 font-18px old-price">${course.price}</p>
      <p className="mb-2 font-18px new-price text-blue">
        <span><strong>${course.sale_price}</strong></span>&nbsp;&nbsp;
        <span className="offer-time">{t('genDict.Limitedtimeoffer')}</span>
      </p></>
    : <></>}
      <div className="d-flex flex-wrap align-items-center justify-content-space-between">
        <div className="mr-2 mt-4">
          {/* <a href="#" className="btn btn-blue text-uppercase">Start learning</a> */}
          {
          course.isOrdered ?
            <button className="btn btn-blue text-uppercase" onClick={() => {
              if (course.curriculums[0] && course.curriculums[0].contents[0])
                // history.push(`/courses/${course.id}/curriculums/${course.curriculums[0].id}/contents/${course.curriculums[0].contents[0].id}`);
                history.push(`/my/courses/${course.id}`);
              else
                notification.error({message: t('genDict.noContentAvailable')});
            }}>
              {t('genDict.viewCourse')}
            </button> :
            <Button className="btn btn-blue text-uppercase" onClick={async () => {
                await addToCart();
                 // ⏳ 2-second delay, Becuase api called simultaniously so no respose in checkout/initiate api
                await new Promise(resolve => setTimeout(resolve, 2000));
                setInitiatedPayment(true);
                try {
                    const { data: { data: orderDetails } } = await API_SERVICE.createOrder();
                    const { data } = await API_SERVICE.createOrderPayPal(orderDetails.id);
                    if (data.href) {
                        window.location.href = data.href;
                    } else if (data.is_free_checkout) {
                        history.push('/my/management/my/courses');
                    }
                } catch (e) {
                    setInitiatedPayment(false);
                    notification.error({
                        message: API_SERVICE.handleErrors(e),
                    });
                }
            }}
              loading={initiatedPayment} disabled={user?.role?.id === 4 ? false : true}>
                {t('genDict.getThisCourse')}
            </Button>
        }
        </div>
        <div className="mr-2 mt-4">
          <img src={checked} style={{width:"18px"}}/>&nbsp;&nbsp;
          <span className="text-blue"> {t('genDict.GloballyRecognised')}</span>
        </div>
        {/* <div className="mr-2 mt-4">
          <img src={checked} style={{width:"18px"}}/>&nbsp;&nbsp;
          <span className="text-blue">{t('genDict.GetCertified')}</span>
        </div> */}
      </div>
      {/* <Card>
        {!course.isOrdered && !settings.is_closed ? <><Title level={4}>{t('genDict.price')}</Title>
          {
            course.price !== course.sale_price &&
            <Text type="danger" delete>{`${t('genDict.actualPrice')} $${course.price}`}</Text>
          }
          <Title level={3}>${course.sale_price}</Title></> : <></>}
        {
          course.isOrdered ?
            <Button type="primary" danger={true} onClick={() => {
              if (course.curriculums[0] && course.curriculums[0].contents[0])
                history.push(`/courses/${course.id}/curriculums/${course.curriculums[0].id}/contents/${course.curriculums[0].contents[0].id}`);
              else
                notification.error({message: t('genDict.noContentAvailable')});
            }} icon={<PlayCircleOutlined/>}
                    size={'large'}>
              {t('genDict.viewCourse')}
            </Button> :
            (addedToTheCart ? <Button disabled type="primary" icon={<ShoppingCartOutlined/>}
                                      loading={addingToCart} size={'large'}>
              {t('genDict.addedToTheCart')}
            </Button> : <Button type="primary" onClick={addToCart} icon={<ShoppingCartOutlined/>}
                                loading={addingToCart} size={'large'}>
              {t('genDict.getThisCourse')}
            </Button>)
        }
      </Card> */}
    </div>
    {/* <List

      itemLayout="horizontal"
      dataSource={items}
      renderItem={item => (
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar icon={item.icon}/>}
            title={<Row>
              <Col flex={'auto'}>
                {t(item.title)}
              </Col>
              <Col>{item.value}</Col>
            </Row>}
          />
        </List.Item>
      )}
    /> */}
  </div>
  }
  </AuthConsumer>

}
